function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import * as S from './ModalBase.styles';
/**
 * ModalBase
 *
 * This provides a basic modal including the overlay and a content container
 * It is up to the consumer to provide the styles for the content.
 */
export function ModalBase(props) {
  const {
    children,
    size = 'medium',
    trigger,
    dialogContentProps,
    portalContainer,
    maxHeight,
    forceBottom,
    ...dialogProps
  } = props;
  return /*#__PURE__*/React.createElement(Dialog.Root, _extends({
    modal: true
  }, dialogProps), trigger ? /*#__PURE__*/React.createElement(Dialog.Trigger, {
    asChild: true
  }, trigger) : null, /*#__PURE__*/React.createElement(Dialog.Portal, {
    container: portalContainer
  }, /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement(S.ModalContent, _extends({
    $modalSize: size,
    $maxHeight: maxHeight,
    $forceBottom: forceBottom
  }, dialogContentProps), /*#__PURE__*/React.createElement(VisuallyHidden, {
    asChild: true
  }, /*#__PURE__*/React.createElement(Dialog.Description, null)), children))));
}
export const Overlay = S.Overlay;